import apiWrapper from 'Helpers/apiWrapper'
import extractApiData from 'Helpers/extractApiData'
import { encodeParams } from 'mailup-react-helpers'

const endpoints = (baseURL => {
  return {
    getListActivation: idList =>
      `${baseURL}/list/${encodeURIComponent(idList)}/activation`,

    getMessageActivation: idMessage =>
      `${baseURL}/message/${encodeURIComponent(idMessage)}/activation`,

    getEndpointsList: params =>
      `${baseURL}/contentendpoints/all?${encodeParams(params)}`,

    getEndpointsAttachToList: idList => `${baseURL}/list/${idList}/activation`,

    getEndpointsAttachToMessage: idMessage =>
      `${baseURL}/message/${idMessage}/activation`
  }
})(process.env.BEPERSONALIZATION_URL)

export const bePersonalizationApiGetListActivation = idList => {
  const url = endpoints.getListActivation(idList)
  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const bePersonalizationApiGetMessageActivation = idMessage => {
  const url = endpoints.getMessageActivation(idMessage)
  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const bePersonalizationApiGetEndpointsList = (
  pageNum = 1,
  pageSize = 0
) => {
  const url = endpoints.getEndpointsList({ pageNum, pageSize })
  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const bePersonalizationApiGetEndpointsAttachToList = idList => {
  const url = endpoints.getEndpointsAttachToList(idList)
  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const bePersonalizationApiGetEndpointsAttachToMessage = idMessage => {
  const url = endpoints.getEndpointsAttachToMessage(idMessage)
  return apiWrapper({
    method: 'get',
    url: url
  }).then(extractApiData)
}

export const bePersonalizationApiSaveEndpointsAttachToMessage = (
  idMsg,
  contentEndpointIds
) => {
  const url = endpoints.getEndpointsAttachToMessage(idMsg)
  return apiWrapper({
    method: 'post',
    url: url,
    data: JSON.stringify(contentEndpointIds),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(extractApiData)
}
